export const toggleItemInArray = (collection: any, item: any) => {
  const index = collection.indexOf(item);
  if (index !== -1) {
    return collection.filter((el: any) => el !== item);
  }
  return [...collection, item];
};

const findChangedPropertiesOfAnObject = (first: any, second: any) =>
  Object.entries(first).reduce(
    (result: any[], [key, value]) =>
      JSON.stringify(value) === JSON.stringify(second[key])
        ? result
        : result.concat(key),
    [],
  );

export const pickChangedValues = (first: any, second: any) => {
  const changedFields = findChangedPropertiesOfAnObject(first, second);
  return Object.fromEntries(
    Object.entries(first).filter(([key]) => changedFields.includes(key)),
  );
};
